export default __webpack_public_path__ + "static/media/sticker_smile_faces.a975edd4.png";